import { useRef } from 'react';
import { v4 as uuid } from 'uuid';

function useUniqueId(id?: string): string {
  const ref = useRef(id || uuid());
  return ref.current;
}

export default useUniqueId;
